export const AGORA_APP_ID = '0a71420073ba42e0a0e9129d893ce9cb'
